import React from 'react';

const MicrophoneIcon = ({ color }) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3548 9.12903V16.5154C18.3548 17.6912 17.4016 18.6444 16.2258 18.6444C15.05 18.6444 14.0968 17.6912 14.0968 16.5154V9.12903C14.0968 7.9532 15.05 7 16.2258 7C17.4016 7 18.3548 7.9532 18.3548 9.12903ZM12.0968 9.12903C12.0968 6.84863 13.9454 5 16.2258 5C18.5062 5 20.3548 6.84863 20.3548 9.12903V16.5154C20.3548 18.7958 18.5062 20.6444 16.2258 20.6444C13.9454 20.6444 12.0968 18.7958 12.0968 16.5154V9.12903ZM10 16.7333C10 16.181 9.55228 15.7333 9 15.7333C8.44772 15.7333 8 16.181 8 16.7333C8 20.7862 11.1936 24.0515 15.2258 24.52V27C15.2258 27.5523 15.6735 28 16.2258 28C16.7781 28 17.2258 27.5523 17.2258 27V24.52C21.258 24.0515 24.4516 20.7862 24.4516 16.7333C24.4516 16.181 24.0039 15.7333 23.4516 15.7333C22.8993 15.7333 22.4516 16.181 22.4516 16.7333C22.4516 19.9107 19.716 22.5778 16.2258 22.5778C12.7356 22.5778 10 19.9107 10 16.7333Z"
      fill={color}
    />
  </svg>
);

export default MicrophoneIcon;
